module.exports = __webpack_public_path__ + "static/media/tool-card-8-icon.7935d940.svg";